export default "__VITE_ASSET__B1dx7SNm__"